module.exports = __webpack_public_path__ + "img/商品详情1-1.c60fcd9a.png";